// extracted by mini-css-extract-plugin
module.exports = {"social-buttons":"styles_social-buttons__104BL","social-button":"styles_social-button__27g7C"};